import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/perfil')({
  beforeLoad: () => {
    throw redirect({ to: '/config', search: { tab: 'perfil' } })
  },
})
